@import '../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.button {
  position: relative;
  border-radius: 100px;
  border: 1px solid transparent;
  background:
    linear-gradient(var(--blue-11003A), var(--blue-11003A)) padding-box,
    conic-gradient(from 0deg, #bcfdb2, #7d8bff 90deg, #ff7977 180deg, #bcfdb2 360deg) border-box;
  gap: @space-8;
  padding: @space-4 @space-8;

  &:hover,
  &:focus {
    background:
      linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)) padding-box,
      linear-gradient(var(--blue-11003A), var(--blue-11003A)) padding-box,
      conic-gradient(from 0deg, #bcfdb2, #7d8bff 90deg, #ff7977 180deg, #bcfdb2 360deg) border-box;
  }
}

.unreadDot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: var(--red-600);
  border-radius: 50%;
  pointer-events: auto;
}
